import React from 'react';
import { Flex } from 'antd';
import { formatCurrency } from '@shared/utils/currency';
import { Currencies } from '@shared/utils/constants';
import { useCentralStore } from '@client/screens/estimates/details/context/CentralStoreContext';

const TceChangeIndicator = () => {
	const { tceDiff, estimate } = useCentralStore();

	if (tceDiff === 0) {
		return null;
	}

	return (
		<Flex gap={10}>
			<span style={{ whiteSpace: 'nowrap' }}>
				<span style={{ marginRight: 4 }}>
					{tceDiff > 0 ? 'The TCE has increased by:' : 'The TCE has decreased by:'}
				</span>
				<span style={{ color: tceDiff > 0 ? 'green' : 'red', marginRight: '0.5rem' }}>
					{tceDiff > 0 ? '↑' : '↓'} {formatCurrency(Math.abs(tceDiff), estimate?.currency ?? Currencies.USD)}
				</span>
			</span>
		</Flex>
	);
};

export default TceChangeIndicator;